// extracted by mini-css-extract-plugin
export default {"child":"multi_page___child___dba270c5","visible":"multi_page___visible___d806f6af"};